// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Logout_logout__2tpRQ * {\n  color: var(--color-primary);\n}\n.Logout_logout__button__2hFM6 {\n  background-color: transparent;\n  border: none;\n  color: var(--color-primary);\n  padding: 0 3px;\n  overflow: hidden;\n  font-weight: bold;\n  position: absolute;\n  right: 5rem;\n  top: 2.45rem;\n}\n@media (max-width: 768px) {\n  .Logout_logout__button__2hFM6 {\n    top: 1.7rem;\n  }\n}", ""]);
// Exports
exports.locals = {
	"logout": "Logout_logout__2tpRQ",
	"logout__button": "Logout_logout__button__2hFM6"
};
module.exports = exports;
